import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
const SvgSparkle = ({ title, titleId, ...props }, ref)=>/*#__PURE__*/ jsxs("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        role: "img",
        ref: ref,
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ jsx("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ jsx("path", {
                d: "M20.3161 9.363C12.8972 8.70217 12.3443 8.17082 11.6604 1C10.9755 8.17082 10.4221 8.70241 3 9.363C10.4221 10.0204 10.9755 10.5591 11.6604 17.7265C12.3443 10.5591 12.8972 10.0204 20.3161 9.363Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M8.60031 16.6231C8.33897 19.3534 8.12731 19.5573 5.30182 19.8097C8.12731 20.0583 8.33897 20.2671 8.60031 23C8.85714 20.2669 9.06881 20.0583 11.8978 19.8097C9.06881 19.5573 8.85714 19.3534 8.60031 16.6231Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M21 13.485C19.1629 13.6524 19.0252 13.7832 18.8549 15.5573C18.6862 13.7832 18.5479 13.6524 16.7109 13.485C18.5479 13.3219 18.6862 13.1917 18.8549 11.4171C19.0252 13.1917 19.1632 13.3219 21 13.485Z",
                fill: "currentColor"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ forwardRef(SvgSparkle);
const Memo = /*#__PURE__*/ memo(ForwardRef);
const Sparkle = Memo;
export { Sparkle as default };
